module.exports = __webpack_public_path__ + "static/media/bubble-msg-04.795c8e62.png";